module.exports = __webpack_public_path__ + "img/phone.978ef588.svg";